import React from "react";
import theme from "./util/theme/default";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import Content from "./components/Content";
import { QueryClient, QueryClientProvider } from "react-query";
import CssBaseline from "@mui/material/CssBaseline";
import { MapContextProvider } from "./contexts";
import "./util/theme/fonts/fonts.css";
import AOS from "aos";
import "aos/dist/aos.css";

const queryClient = new QueryClient();

const params = new URLSearchParams(window.location.search);
const lang = params.get("lang") === "es" ? "es" : "en";
theme.lang = lang;
document.documentElement.lang = lang;

function App() {
  AOS.init();

  return (
    <QueryClientProvider client={queryClient}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline />

          <MapContextProvider>
            <Content />
          </MapContextProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </QueryClientProvider>
  );
}

export default App;
